import type { PrefetchContext } from '@change-corgi/core/react/prefetch';

import { prefetchFcm } from './hooks/fcm';
import { prefetchLogoFcm } from './hooks/logoVariation';

export async function prefetch(context: PrefetchContext): Promise<void> {
	await Promise.all([prefetchFcm(context), prefetchLogoFcm(context)]);
}
